import { render } from "./uploadForm.vue?vue&type=template&id=849b653e"
import script from "./uploadForm.vue?vue&type=script&lang=js"
export * from "./uploadForm.vue?vue&type=script&lang=js"

import "./uploadForm.vue?vue&type=style&index=0&id=849b653e&lang=css"
script.render = render

export default script